import { getIntl } from '@umijs/max';
import type { Rule } from 'antd/es/form';

/**
 * 表单验证规则工具类
 */

/** 常用正则表达式 */
export const patterns = {
  /** TIN号码:3-3-3-3 或 3-3-3-5 位数字,半角连字符分隔(与租户端一致) */
  tinNumber: /^\d{3}-\d{3}-\d{3}-(\d{3}|\d{5})$/,
  /** 菲律宾手机号：09开头11位 或 +63/63开头12位 */
  phoneNumber: /^(09\d{9}|\+63\d{10}|63\d{10})$/,
  /** 邮箱 */
  email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  /** 仅英文 */
  englishOnly: /^[a-zA-Z]+$/,
  /** 仅数字 */
  numberOnly: /^\d+$/,
  /** 英文和数字 */
  alphanumeric: /^[a-zA-Z0-9]+$/,
  /** 英文、数字、中划线 */
  alphanumericDash: /^[a-zA-Z0-9-]+$/,
  /** 英文、数字、下划线 */
  alphanumericUnderscore: /^[a-zA-Z0-9_]+$/,
  /** 英文、数字、中划线、下划线 */
  slug: /^[a-zA-Z0-9_-]+$/,
  /** 账号密码:6-20 位,同时包含字母和数字,不含中文(后端改密同为 6-20 位) */
  password: /^(?=.*[a-zA-Z])(?=.*\d)[^一-龥]{6,20}$/,
};

/** 预定义的表单验证规则 */
export const formRules = {
  /** TIN号码验证(非必填,留空不校验;文案沿用租户端 validators.tinNumberFormat) */
  tinNumber: (
    message = getIntl().formatMessage({ id: 'validators.tinNumberFormat' }),
  ): Rule => ({
    pattern: patterns.tinNumber,
    message,
  }),

  /** 菲律宾手机号验证(文案沿用租户端 validators.phoneNumberFormat) */
  phoneNumber: (
    message = getIntl().formatMessage({ id: 'validators.phoneNumberFormat' }),
  ): Rule => ({
    pattern: patterns.phoneNumber,
    message,
  }),

  /** 邮箱验证(文案走内置 locales,默认参数调用期求值,语言切换即时生效) */
  email: (
    message = getIntl().formatMessage({ id: 'validators.emailFormat' }),
  ): Rule => ({
    pattern: patterns.email,
    message,
  }),

  /** 仅英文验证 */
  englishOnly: (
    message = getIntl().formatMessage({ id: 'validators.englishOnly' }),
  ): Rule => ({
    pattern: patterns.englishOnly,
    message,
  }),

  /** 仅数字验证 */
  numberOnly: (
    message = getIntl().formatMessage({ id: 'validators.numberOnly' }),
  ): Rule => ({
    pattern: patterns.numberOnly,
    message,
  }),

  /** 英文和数字验证 */
  alphanumeric: (
    message = getIntl().formatMessage({ id: 'validators.alphanumeric' }),
  ): Rule => ({
    pattern: patterns.alphanumeric,
    message,
  }),

  /** 英文、数字、中划线验证 */
  alphanumericDash: (
    message = getIntl().formatMessage({ id: 'validators.alphanumericDash' }),
  ): Rule => ({
    pattern: patterns.alphanumericDash,
    message,
  }),

  /** 账号密码强度(系统用户/租户管理员/修改密码三处统一) */
  password: (
    message = getIntl().formatMessage({ id: 'validators.passwordPattern' }),
  ): Rule => ({
    pattern: patterns.password,
    message,
  }),
};
